/**
 * The one PostHog capture seam for the Pro analytics builders (pro-home,
 * marketplace profile). A builder returns a fixed-shape `{ event, props }`;
 * this is the only place that touches the client, following the Pro
 * convention (`usePostHog()` + `posthog?.capture`): no provider key (preview,
 * local dev) means no client and the call is a no-op.
 */

export interface CaptureClient {
  capture: (event: string, props?: Record<string, unknown>) => void;
}

export interface CaptureEvent {
  event: string;
  props: Record<string, unknown>;
}

export function captureEvent(
  posthog: CaptureClient | null | undefined,
  evt: CaptureEvent,
): void {
  posthog?.capture(evt.event, evt.props);
}
